var indexOf = require('./indexOf');

    /**
     * Remove a single item from the array.
     * (it won't remove duplicates, just a single item)
     */
    function remove(arr, item){
        var idx = indexOf(arr, item);
        if (idx !== -1) arr.splice(idx, 1);
    }

    module.exports = remove;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/array/remove.js
// module id = 143
// module chunks = 1